// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-editor-edit_panel-wireframe_replace__suggestedComponentsIcon {\n  width: 12px;\n  height: 12px;\n  color: #686868;\n}\n", "",{"version":3,"sources":["webpack://./src/editor/edit_panel/wireframe_replace.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,cAAgB;AAClB","sourcesContent":[".suggestedComponentsIcon {\n  width: 12px;\n  height: 12px;\n  color: colorGrey;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"suggestedComponentsIcon": "src-editor-edit_panel-wireframe_replace__suggestedComponentsIcon"
};
export default ___CSS_LOADER_EXPORT___;
